export default __webpack_public_path__ + "static/media/AKanban.a6fe4e08.svg";